/**
 * VERSIONE LIBRERIA 3
 */

var CoreView = Class.extend({
    modelName           : null, 
    renderObjs          : [],
    config              : {},
    data                : {},
    prefixTemplateClass : 'default',
    type                : null,
    jQe                 : null,
    langs               : [],
    //defaultRenderType   : null,
    defaultRenderClassName : null,
    connectedObjs       : {},
    routeType           : null,     // oggetto route da utilizzare per prendere i dati
    keyId               : null,     // identificativo univoco della view creata e assegnata dal controller
    _controller         : null,     // controller proprietario della view
    _customAttrs        : {},       // attributi per le view custom personalizzabili a seconda delle esigenze
    // mapping delle viste con i tipi default dei render
    viewTypeToRenderType : {
        'list'      : BaseElement.VIEW,
        'edit'      : BaseElement.EDIT,
        'search'    : BaseElement.SEARCH,
        'view'      : BaseElement.VIEW,
        'calendar'  : BaseElement.VIEW,
        'csv'       : BaseElement.EDIT
    },

    init: function (modelName,config,data) {
        this.modelName = modelName;
        this.renderObjs = {};
        this.connectedObjs = {};
        this.data = data?data:{};
        this.setConfig(config);
        this._customAttrs = {};
    },

    setConfig : function (config) {
        if (this.config)
            delete this.config;
        this.config = config?config:{};
        this.langs = this.config.langs?this.config.langs:['it'];
        this.prefixTemplateClass = this.config.prefixTemplateClass?this.config.prefixTemplateClass:'default';
        if (config && config.afterLoadData)
            this.afterLoadData = config.afterLoadData;
        if (config && config.afterRender)
            this.afterRender = config.afterRender;
    },
    setController : function (controller) {
        this._controller = controller;
    },
    // renderizza rotellina nell'area dedicata alla view
    renderWait : function () {
        var self = this;
        log.warn("renderWait obsoleta con introduzione di templatecustom");
        return ;
        if ($(self.config.container).length !== 0) {
            $(self.config.container).html($('#default_big_spinner_tpl').html());
        }
    },
    /**
    * render della view
    **/
    render : function () {
        var self = this;
        if (self.config.custom) {
            self.jQe = $(self.config.container);
            if (self.config.customTemplate) {
                $(self.config.container).html($(self.config.customTemplate).html())
            }
            console.log("custom " + self.config.custom);
            var customName = Utility.pascalCase(self.config.custom);
            var configFunction = '_configViewCustom'+customName;
            var renderFunction = '_renderViewCustom'+customName;

            if (!_.isFunction(self[renderFunction])) {
                throw 'View'+ self.type + '.'+ renderFunction + ' not implemented';
            }

            if (_.isFunction(self[configFunction])) {
                self[configFunction](self.config.container);
            }
            self._setKeys();
            self[renderFunction](self.config.container);
            //self._renderCustom($(self.config.container));
            $.translateDocument(self.config.container);
            self._finalize();
            return $(self.config.container).html();
        }
        log.debug("CoreView.render",self.keyId,self.type,self.config.contaner);
        var obj = self._getTemplate();
        // aggiungo un attributo di riconoscimento al template della view
        if (obj.children().length > 0) {
            $(obj.children()[0]).attr('data-view_model',self.modelName);
            $(obj.children()[0]).addClass(self.modelName);
        }
        if (!_.isFunction(self.render))
             throw 'View'+ self.type + '._render not implemented';
        // rendo univoci gli id di eventuali tab
        $.each($(obj).find('[role="tablist"]').find('a'),function () {
            var href = $(this).attr('href').substr(1);
            $(this).attr('href','#'+self.keyId+href);
            $(this).html($.translate(self.config.groups[href].title));
        });
        // creo gli id dei gruppi per le view raggruppate
        $.each($(obj).find('[data-group]'),function () {
            $(this).attr('id',self.keyId+ $(this).attr('data-group')); //$(this).attr('id'));
        });

        $(self.config.container).html('');
        $(self.config.container).html(obj.html());
        obj.remove();
        //delete obj;
        self.jQe = $(self.config.container);
        self._render();
        // disabilito il submit automatico  della form in caso di return
        $(self.config.container).find('input').on('keypress', function(e) {
            return e.which != 13;
        });
        self._finalize();
        $.translateDocument(self.config.container);
        return $(self.config.container).html();
    },
    setData : function (data) {
        this.data = data;
    },

    // getFormData : function () {
    //     var self = this;
    //     var form = $(self.config.container).find('form[name="data_form"]');
    //     if (form.length === 0)
    //         return {};
    //     if (typeof tinyMCE !== 'undefined') {
    //         tinyMCE.triggerSave();
    //     }
    //     return form.serializeAssoc();
    // },

    getFormData : function () {
        var self = this;
        var form = $(self.config.container).find('form[name="data_form"]');
        if (form.length === 0)
            return {};
        if (typeof tinyMCE !== 'undefined') {
            tinyMCE.triggerSave();
        }
        var formData =  form.serializeAssoc();
        var postData = {}
        // trasformo tutti gli [d] in [] questa modifica e' fatta per gestire i radio button negli hasmany
        // altrimenti venivano raggruppati come un unica entita'
        for( var k in formData) {
            if (formData[k].constructor !== Array) {
                postData[k] = formData[k];
                continue;
            }
            var pattern = /(.+)(\[\d+\])(.*)$/g;
            var match = pattern.exec(k);
            if (match && match.length == 4) {
                var newkey = match[1] + '[]' + match[3];
                if (!postData[newkey])
                    postData[newkey] = [];
                postData[newkey].push(formData[k]);
                delete formData[k];
            }  else {
                postData[k] = formData[k];
            }
        }
        return postData;
    },

    getModelData : function () {
        var self = this;
        throw 'CoreView.getModelData is abastract. viewType is ' + self.type;
    },



    _getTemplate : function () {
        var self = this;
        var tplId = self.config.templateId;
        if (!tplId) {

            if (self.config.groups) {
                var groupLength = _.keys(self.config.groups).length;
                self.config.templateId = '#'+ self.prefixTemplateClass +'_view_'+self.type+'_group' + groupLength + '_tpl';
                tplId = self.config.templateId;
            } else {
                tplId = '#' + self.prefixTemplateClass + '_view_' + self.type + '_tpl';
                if ($(tplId).length === 0)
                    throw 'View: Template source ' + tplId + ' Not found';
            }
        }

        return $.createDynamicContainer(tplId);
    },
    /**
     * ritorna il nome della classe in base al tipo di render
     */
    getRenderClass : function (type) {
        return "Render" + Utility.pascalCase(type);
    },
    /**
     * crea un nuovo oggetto action a partire da quello passato. ogni azione nella view
     * deve essere un nuovo oggetto rispetto a quello che c'e' nella configurazione
     * @param {string} actionName
     * @param {object} params
     * @private {object} nuova copia dell'azione
     */
    _buildSingleAction : function (actionName,params) {
        var action = null;
        // TODO controllare se ci sia bisogno davvero di fare un nuovo oggetto
        if (params instanceof CollectionAction)
            action = new CollectionAction();
        else
            action = new RecordAction();
        action.action = actionName;
        for(var f in params)
            action[f] = params[f];
        //action.func = params.func;             
        return action;
    },

    _buildFunctionParams : function () {
        throw this.type + " ._buildFunctionParams not implemented";
    },
    /**
     * esegue la valutazione della prop di un oggetto action che puo' essere
     * un valore semplice o una funziona
     * @param prop: property della action da analizzare
     **/
    _evaluateFunctionProp : function () {
        throw this.type + " ._evaluateFunctionProp not implemented";
    },
    getRenderObj : function(key) {
        throw this.type + " .getRenderObj not implemented";
    },


    // --- abstract metod
     /**
     * metodo da overloadare che verra' richiamato in seguito dall'oggetto CoreView.
     * @param jQe : elemento jquery contenente il template sorgente
     */
    _render : function (jQe) {
        throw '_render Not implemented';
    },

    _renderViewCustomBase : function (jQe) {
        throw '_renderViewCustomBase Not implemented';
    },
    _renderViewCustomComplex : function (jQe) {
        throw '_renderViewCustomComplex Not implemented';
    },
    /**
     * metodo opzionale verra' chiamato quando l'html e' stato tutto renderizzato
     */
    _finalize : function () {
        //throw '_finalize Not implemented';
    },

    _finalizeCustom : function () {

    },
    /*
    *   restituisce la modalita' in cui verra' disegnato l'oggetto render
    * in base alla configurazione dell'oggetto nell control_type della view
    */
    _getRenderMode : function (key) {
        var self = this;
        // il mode dell'oggetto render di default in base al tipo di view
        var mode = self.viewTypeToRenderType[self.type];
        if (self.config.fields_type[key] && self.config.fields_type[key].mode)
            mode = self.config.fields_type[key].mode;
        return mode;
    },
    /**
     * ritorna il type del render in base al type definito nella fields_type della view
     * @params key : chiave dell'oggetto render
     *
     **/
    _getRenderType : function (key) {
        var self = this;
        var type = (self.config.fields_type[key] && self.config.fields_type[key].type)?self.config.fields_type[key].type:self.defaultRenderType;
        return type;
    },
    /*
    _getRenderClassName : function (key) {
        var self = this;
        var type = (self.config.fields_type[key] && self.config.fields_type[key].className)?self.config.fields_type[key].className:self.defaultRenderClassName;
        return type;
    },
    */
    /**
     * ritorna la configurazione di default dell'oggetto render
     * @params key : chiave dell'oggetto render
     **/
    _getDefaultRenderConfig : function(key) {
        var self = this;
        // preparo la configurazione minima di default
        var rconfig = {
            mode : self._getRenderMode(key),
            modelName : self.modelName,
            langs : self.langs
        };
        // aggiungo operatore in caso di search
        if (self.config.operator && self.config.operator[key])
            rconfig['operator'] = self.config.operator[key];
        return rconfig;
    },
    /**
     * prepara i campi di configurazione per l'oggetto render
     * @params key : chiave dell'oggetto render
     **/
    _getRenderConfig : function(key,realType) {
        var self = this;
        var rconfig = self._getDefaultRenderConfig(key);
        if (!self.config.fields_type[key])
            return rconfig;

        // passo le configurazione del type nella view alla configurazione del render
        for (var i in self.config.fields_type[key]) {
            rconfig[i] = self.config.fields_type[key][i];
        }

        var type = self._getRenderType(key);
        var classConfig = Render.getClassData(type);

        var funcName = "_get" + classConfig + "Config";
        if (_.isFunction(self[funcName])) {
            return self[funcName](key,rconfig);
        }
        return rconfig;

        /*

        var type = self._getRenderType(key);
        if (realType)
            type = realType;
        var funcName = "_get" + self.getRenderClass(type) + "Config";
    
        if (_.isFunction(self[funcName])) {
            return self[funcName](key,rconfig);
        }

        // configurazioni speciali compatibilita' all'indietro
        switch(self.config.fields_type[key].type) {
            case 'radio':
                rconfig.choiceType = 'radio';
                break;
            //case 'checkbox':
            //    rconfig.choiceType = 'select';
            case 'attachment':
            case 'foto':
                rconfig.uploadType = self.config.fields_type[key].type;
                break;
            case 'map':

                break;
            case 'switchlink':
                //rconfig.type = 'swap';

        }

        return rconfig;
        */

    },
    // configurazioni speciali 
    _getRenderHasmanyConfig : function (key,rconfig) {
        var self = this;
        rconfig.metadata = self.data.metadata[key];
        rconfig.modelConf = self.config.fields_type[key].modelConf;
        return rconfig;
    },
    _getRenderHasmanyThroughConfig : function (key,rconfig) {
        var self = this;
        if (!rconfig.autocompleteModel)
            rconfig.autocompleteModel = Utility.snakeCase(self.data.resultParams[key].modelRelativeName);
        //rconfig.modelConf = self.config.fields_type[key].modelConf;
        return rconfig;
    },

    _getRenderAutocompleteConfig : function (key,rconfig) {
        var self = this;
        if (!rconfig.autocompleteModel)
            rconfig.autocompleteModel = Utility.snakeCase(self.data.resultParams[key].modelRelativeName);
        //rconfig.modelConf = self.config.fields_type[key].modelConf;
        return rconfig;
    },
    _getRenderMapConfig : function (key,rconfig) {
        var self = this;
        var indirizzo = "";
        if (self.config.fields_type[key].address_map) {
            for (var f in self.config.fields_type[key].address_map) {
                if (self.data.value[  self.config.fields_type[key].address_map[f]  ])
                    indirizzo += self.data.value[  self.config.fields_type[key].address_map[f]  ] + " ";
            }
        }
        rconfig.address = indirizzo;
        //rconfig.modelConf = self.config.fields_type[key].modelConf;
        return rconfig;
    },
    _getRenderVideoConfig : function(key,rconfig) {
        var self = this;
        rconfig.provider = self.data.resultParams['videos'].fields.provider.options;
        return rconfig;
    },
    /*
    _getRenderHasmanyConfig : function (key,rconfig) {
        var self = this;
        rconfig.metadata = self.data.metadata[key];
        rconfig.modelConf = self.config.fields_type[key].modelConf;
    },
    _getRenderHasmanyConfig : function (key,rconfig) {
        var self = this;
        rconfig.metadata = self.data.metadata[key];
        rconfig.modelConf = self.config.fields_type[key].modelConf;
    },
    */


    // da overloadare
    _attachEvents : function () {
        return ;
    },

    
    _attachEvent : function (render,pk) {
        var self = this;
        render.fireEvent = function (evt) {
            evt.pk = pk;
            self.fireToConnected(evt);
            self.fireEvent(evt);
        };
    },
    fireEvent : function (evt) {
        var self = this;
        log.warn('CoreView.fireEvent ' + evt.eventName  + '  view ' + evt.type + ' not overladed');
        return ;
    },
    fireToConnected : function (evt) {
        throw ' fireToConnected not implemented';
    },
    /**
     * restituisce l'oggetto data da assegnare all'oggetto render
     */
    _getRenderData : function (key) {
        throw ' _getRenderData not implemented';
    },

    _setKeys : function () {
        throw ' _setKeys not implemented';
    },

    // eventi di default chiamati dal sistema
    afterLoadData : function () {
        log.debug(this.keyId,this.modelName,this.type,'default afterLoadData');
    },
    afterRender : function () {
        log.debug(this.keyId,this.modelName,this.type,'default afterRender');
    }
});
